import {entorno} from "./environment.entorno";

const tenant = entorno.tenant;
const clientId = entorno.clientId;
const redirectUri = entorno.redirectUri;

export const environment = {
  production: entorno.production,
  endpointDocente: entorno.endpointDocente,
  endpointAdministrativo: entorno.endpointAdministrativo,
  endpointIntegracion: entorno.endpointIntegracion,
  loginUrl: `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=openid&response_type=code`,
  logoutUrl: `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/logout`,
  devLocal: entorno.devLocal,
  tiempoSocketEstadoAlumnos: entorno.tiempoSocketEstadoAlumnos,
  tiempoReconexionSocket: entorno.tiempoReconexionSocket,
  appInsights: entorno.appInsights,
};
